// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse {
  0% {
    stroke-width: 5;
    opacity: 1;
  }
  100% {
    stroke-width: 20;
    opacity: 0;
  }
}

.cmap [class*="point-shape"] {
  animation: pulse 1.5s ease-in-out infinite;
}

.cmap {
  --vis-map-point-ring-fill-color: #ff0000;
}
`, "",{"version":3,"sources":["webpack://./src/examples/maps/topojson/complex-demo/style.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["@keyframes pulse {\n  0% {\n    stroke-width: 5;\n    opacity: 1;\n  }\n  100% {\n    stroke-width: 20;\n    opacity: 0;\n  }\n}\n\n.cmap [class*=\"point-shape\"] {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.cmap {\n  --vis-map-point-ring-fill-color: #ff0000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cmap": `cmap`,
	"pulse": `pulse`
};
export default ___CSS_LOADER_EXPORT___;
